import React from 'react';
import { MdOutlineEdit } from 'react-icons/md';

const EditButton = ({ onClick }) => {
    return (
        <button
            onClick={onClick}
            className="group relative inline-flex h-10 items-center justify-center overflow-hidden rounded-md bg-blue-600 text-main-white px-4 font-medium transition hover:bg-blue-500/80 hover:scale-105"
        >
            <MdOutlineEdit className="me-2" /> {/* Edit Icon */}
            <span>Edit</span>
            <div className="absolute inset-0 flex h-full w-full justify-center [transform:skew(-12deg)_translateX(-100%)] group-hover:duration-1000 group-hover:[transform:skew(-12deg)_translateX(100%)]">
                <div className="relative h-full w-8 bg-white/20"></div>
            </div>
        </button>
    );
}

export default EditButton;
